// @flow strict
import * as React from 'react';
import { Lozenge } from '../Lozenge';
import styles from './styles.scss';

export type BadgePropType = {|
  variant?: 'Notification' | 'New' | 'Beta',
|};

export const Badge = ({ variant = 'Notification' }: BadgePropType) => {
  switch (variant) {
    case 'New':
      return (
        <Lozenge
          className={styles.newLozenge}
          text="NEW"
          backgroundColor="#1e8c0d"
          textColor="white"
        />
      );
    case 'Beta':
      return (
        <Lozenge
          className={styles.newLozenge}
          text="BETA"
          backgroundColor="#1e8c0d"
          textColor="white"
        />
      );
    default:
      return <i className={styles.notification} />;
  }
};
